// extracted by mini-css-extract-plugin
export default {"component":"f+K3b"};